<template>
  <v-row dense align="center" class="pb-3">
    <v-col>
      <DateRangePicker
        :start.sync="dateFrom"
        :end.sync="dateTo"
        type="month"
        :disabled="loading"
        :filled="false"
        :allowed-dates="
          (date) => date <= new Date().toISOString().substr(0, 10)
        "
        :max-value="lastDayOfMonth"
        @change="changeFilter"
      />
    </v-col>
    <v-col>
      <ClientSelect
        v-model="client"
        :label="label"
        :disabled="loading"
        :is-dense="true"
        :client-id="client && client.id"
        placeholder="Введіть назву клієнта"
        @input="changeFilter"
      />
    </v-col>
    <slot />
  </v-row>
</template>

<script>
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import ClientSelect from "@/components/selects/ClientSelect.vue";

export default {
  components: {
    ClientSelect,
    DateRangePicker,
  },
  props: ["value", "loading"],
  data: () => ({
    dateFrom: "",
    dateTo: "",
    client: null,
    label: "Фільтр по клієнтам",
    refresh: "refresh",
  }),

  computed: {
    filterReady() {
      return this.dateFrom && this.dateTo && this.client;
    },
    lastDayOfMonth() {
      const today = new Date();
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return lastDay.toISOString().substr(0, 10);
    },
  },

  methods: {
    changeFilter() {
      if (this.filterReady) {
        this.$emit("input", {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          client: this.client,
        });
      }
    },
  },
};
</script>

<style>
/* :TODO replace this in assets folder with global app styles */
.v-select__selection {
  padding-top: 7px !important;
}
</style>
